import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import '@digital-realty/ix-textbox';
import { IxSearchBarStyle } from './ix-search-bar-styles.js';
import { Item, TextChangeEvent } from './types/index.js';

export class IxSearchBar extends LitElement {
  @property({ type: String }) value = '';

  @property({ type: Array }) items: Item[] = [];

  @property({ type: Array }) searchFields: string[] = [];

  @property({ type: Array }) foundItems: Item[] = [];

  static get styles() {
    return [IxSearchBarStyle];
  }

  connectedCallback() {
    super.connectedCallback();
    this.resetResults();
  }

  resetResults() {
    this.foundItems = this.items;
  }

  get itemsCount() {
    if (Array.isArray(this.foundItems) && this.foundItems.length) {
      return this.foundItems.length;
    }
    return 0;
  }

  get itemsLabel() {
    return this.itemsCount === 1 ? 'item' : 'items';
  }

  _dispatchEvent(items: Item[]): void {
    const resultsEvent = new CustomEvent('onResultsFound', {
      detail: { items },
      composed: true,
    });
    this.dispatchEvent(resultsEvent);
  }

  filterItems(value: string) {
    this.value = value;
    if (value === '') {
      this.resetResults();
      this._dispatchEvent(this.items);
      return;
    }

    const results: Item[] = [];

    for (const item of this.items) {
      for (const field of this.searchFields) {
        if (field in item) {
          if (
            item[field]
              .toLocaleLowerCase()
              .includes(this.value.toLocaleLowerCase())
          ) {
            results.push(item);
            break;
          }
        }
      }
    }

    this.foundItems = results;
    this._dispatchEvent(results);
  }

  render() {
    return html`
      <ix-textbox
        type="search"
        @textChange="${(e: TextChangeEvent) =>
          this.filterItems(e.detail.value)}"
      ></ix-textbox>

      <div class="items-count">${this.itemsCount} ${this.itemsLabel}</div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'ix-search-bar': IxSearchBar;
  }
}
